<template>
  <div class='main'>
    <div class="loginEwm" v-show="!isState">
      <div class="waitMask" v-if="ewmUrl == ''">
        <van-loading type="spinner" color="#1989fa"/>
        <p>二维码生成中...</p>
      </div>
      <img :src="ewmUrl" alt="">
      <p class="desc">请使用补偿本人的交管12123App扫一扫登录（补偿还需要获取您的驾考信息作为凭证，请尽快完成扫码登录，二维码会在3分钟后失效哦）</p>
    </div>
    <div class="process" v-if="processFlag">
      <van-progress :percentage="processNum" stroke-width="8"/>
      <p class="tips">系统正在自动获取驾考信息，请您耐心等待，<br/>不要关闭当前页面！</p>
    </div>
    <div class="stateDiv" v-show="isState">
      <img v-if="stateType == 1" src="../../assets/img/success.png" alt="">
      <img v-else src="../../assets/img/error.png" alt="">
      <p v-if="stateType == 1" class="desc">补偿申请成功</p>
      <p v-else class="desc">补偿申请失败<span>{{ errorDesc }}</span></p>
    </div>
    <div style="color: red;margin: 20px 0px">如果二维码超过一分钟未加载，请点击重新获取二维码</div>
    <el-button type="primary"  style="width: 80%;margin-left: 10%;margin-top: 20%" @click="getLoginImage">重新获取二维码</el-button>
    <popup ref="popupShows"></popup>
    <ajaxLoading ref="loading"></ajaxLoading>
    <maskPopup ref="maskShow"></maskPopup>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import popup from '../common/commonComponents/popup';
import ajaxLoading from '../common/commonComponents/loading';
import maskPopup from '../common/commonComponents/maskDiv';
import {Config, ROUTES} from "../common/api";
import './../common/reset.scss';
import './../common/common';
import Qs from 'qs';
import {Progress, Loading,Toast} from 'vant';
Vue.use(Progress).use(Loading);
export default {
  name: "login",
  data() {
    return {
      loading: false,
      isState: false, // 截图状态
      processFlag: false, // 截图状态
      ewmUrl: '',
      token: '',
      checkIN: '',// 查询状态定时器
      checkINCount: 0,// 查询次数
      processNum: 0,
      processTime: '', // 进度条定时器
      bdOrderInfo: {}, // 缓存信息
      stateType: 1,
      errorDesc: '',
    };
  },
  components: {
    popup,
    ajaxLoading,
    maskPopup
  },
  mounted() {
    document.getElementsByTagName('title')[0].innerText = '扫码登录';
    this.bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
    this.restImage()
  },
  methods: {
    restImage() {
      this.loading = false
      this.isState = false
      this.processFlag = false
      this.ewmUrl = ''
      this.token = ''
      this.checkIN = ''
      this.checkINCount = 0
      this.processNum = 0
      this.processTime = ''
      this.bdOrderInfo = {}
      this.stateType = 1
      this.errorDesc = ''
      // this.getResultImg();
      // this.getProcess();
      this.getLoginImage();
      clearInterval(this.checkIN);

    },
    // 获取登录的二维码
    getLoginImage(){
      const that = this;
      const url = Config.api_url + "applets-server/api/screenshots/getLoginQrCode";
      let bdOrderInfoTemp =  JSON.parse(localStorage.getItem('bdOrderInfo'))
      console.log("bdOrderInfoTemp",bdOrderInfoTemp)
      this.$ajax({
        method: "post",
        url: url,
        data:{
          claimId:bdOrderInfoTemp.policyId,
          lpkm:bdOrderInfoTemp.claimClassCode,
          kssj:bdOrderInfoTemp.policyTime
        }
      }).then(function (res) {
        const data = res.data;
        that.ewmUrl = 'data:image/png;base64,' + data.data.img;
        sessionStorage.setItem("123token",data.data.token)
        that.getStatus();
      })
    },
    // 获取状态
    getStatus(){
      const that = this;
      let token = sessionStorage.getItem('123token');
      const url = Config.api_url + "applets-server/api/screenshots/getStatus/"+token;
      if (token){
      //   开始定时获取数据，2秒执行一次
      //   this.checkIN =  setInterval(()=>{
          this.$ajax({
            method: "get",
            url: url,
          }).then(function (res) {
              const data = res.data;
              console.log("扫码状态",data.data.code == '201')
              if (data.data.code == '200'){
                // 扫码成功后，开始进行截图
                that.getImage(token);
                clearInterval(that.checkIN);
              }else {
                if (data.data.code == '400'){
                  this.$message({
                    type:"error",
                    message:"二维码已失效，请重新扫码"
                  })
                  that.getLoginImage();
                }else {

                  that.getStatus();
                }
                // setTimeout(()=>{

                // that.$message({
                //   type:"error",
                //   message:"请重新扫码"
                // })
                // that.ewmUrl = "";
                // clearInterval(that.checkIN);
                // that.getLoginImage()
              }
          })
        // },4000)
      }
    },
    // 截图请求最新
    getImage(token){
      const that = this;
      console.log("开始进行处理")
      this.$ajax({
        method: "get",
        url: Config.api_url + "applets-server/api/screenshots/getScreenshots/"+token,
      }).then(res => {
        console.log("res--------------------",res)
        that.$refs.maskShow.maskFlag = true;
        that.processFlag = true;
        that.processNum = res.data.data
        if (res.data.data == 100){
          that.processNum = 100;
          that.isState = true;
          that.$refs.maskShow.maskFlag = false;
          that.processFlag = false;
          that.stateType = 1;
        }else {
          setTimeout(()=>{
            that.getImage(token);
          },2000)
        }
      })
    },
    // 截图请求
    getResultImg() {
      const that = this;
     let bdOrderInfoTemp =  JSON.parse(localStorage.getItem('bdOrderInfo'))
      console.log("bdOrderInfoTemp",bdOrderInfoTemp)
      console.error("infossssss", {
        imageId: localStorage.getItem('infoToken'),
        test_kskm:bdOrderInfoTemp.claimClassCode,
        policyId: bdOrderInfoTemp.policyId
      })
      this.$ajax({
        method: "post",
        url: Config.api_url + 'py_insure/picturesave',
        data: Qs.stringify({
          imageId: localStorage.getItem('infoToken'),
          test_kskm:bdOrderInfoTemp.claimClassCode,
          policyId: bdOrderInfoTemp.policyId
        }),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(res => {
        const data = res.data;
        that.isState = true;
        that.$refs.maskShow.maskFlag = false;
        that.processFlag = false;
        clearInterval(that.checkIN);
        if (data.code == '200') {
          that.stateType = 1;
        } else {
          that.stateType = 2;
          that.errorDesc = data.data;
        }
      }).catch(err => {
        clearInterval(that.checkIN);
        that.errorDesc = err;
        Toast.success('访问异常，请重新尝试扫码')
        setTimeout(()=>{
          that.restImage()
        },3000)
      });
    },
    // 获取登录token+截图进度
    getProcess() {
      let bdOrderInfoTemp =  JSON.parse(localStorage.getItem('bdOrderInfo'))
      const that = this;
      this.checkIN = setInterval(() => {
        that.checkINCount++;
        if (that.checkINCount >= 300) {
          clearInterval(that.checkIN);
        }
        that.$ajax({
          method: "post",
          url: Config.api_url + 'py_insure/picturesearch',
          data: Qs.stringify({
            imageId: localStorage.getItem('infoToken'),
            policyId: bdOrderInfoTemp.policyId
          }),
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(res => {
          const data = res.data;
          if (!that.ewmUrl && data.code == '200') {
            that.ewmUrl = 'data:image/png;base64,' + data.data;
          }
          if (data.code == '201') {
            that.$refs.maskShow.maskFlag = true;
            that.processFlag = true;
            if (!that.processTime) {
              that.processNum = 1;
              that.processTime = setInterval(() => {
                that.processNum += 1;
                if (that.processNum == 30) {
                  clearInterval(that.processTime);
                }
              }, 500);
            }
          } else if (data.code == '202') {
            clearInterval(that.processTime);
            that.$refs.maskShow.maskFlag = true;
            that.processFlag = true;
            if (data.pictureNum && data.pictureNum != 0) {
              const num = 30 + parseInt(data.pictureNum || 0) * 10;
              that.processNum = num > 99 ? 99 : num;
            }
          }
        }).catch(err => {

        });
      }, 1000)
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
$them: #067adc;
* {
  margin: 0;
  padding: 0;
}

.main {
  padding-top: 50px;

  .loginEwm {
    text-align: center;
    position: relative;

    img {
      display: block;
      width: 240px;
      height: 240px;
      border: 15px solid #ededed;
      margin: 0 auto 25px;
      border-radius: 8px;
      box-sizing: content-box;
    }

    .waitMask {
      position: absolute;
      width: 270px;
      height: 270px;
      padding-top: 90px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 8px;

      p {
        margin-top: 10px;
        color: $them;
        font-size: 14px;
      }
    }

    .desc {
      line-height: 20px;
      color: #2486ff;
      text-align: center;
      font-size: 15px;
      padding: 0 20px;
    }
  }
}

.popup {
  width: 100%;
  padding: 0 0.75rem;
  background-color: transparent;
  z-index: 1003;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.process {
  position: fixed;
  width: 90%;
  top: 40%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 9999;

  .tips {
    margin-top: 20px;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }
}

.stateDiv {
  img {
    display: block;
    margin: 105px auto 20px;
    width: 81px;
    height: 81px;
  }

  .desc {
    text-align: center;
    color: #333;
    font-size: 15px;

    span {
      display: block;
      font-size: 13px;
      color: #999;
      padding: 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?b6dc263a